/**
 * Time to wait after a typed search settles with empty results before
 * firing the "+ Add Investor Account" autoselect prompt.
 *
 * Why 2000ms:
 *
 * 1. Long enough to confirm intent. Inter-keystroke pauses while a user
 *    is still typing are typically <500ms. A 2s pause is well past
 *    "still thinking what to type" and into "I've stopped and I'm
 *    reading the empty state." Below ~1s, slow typists with thinking
 *    pauses would get their input replaced mid-thought.
 *
 * 2. Short enough to feel responsive. The original PR #5194 affordance
 *    fired the prompt instantly on settled-empty. 2s preserves the
 *    affordance with a small delay that's perceptible but not
 *    frustrating. Above ~3s the user wonders if the feature is broken.
 *
 * 3. Covers the NgRx sub-race. The state observable and success$
 *    subscriber that drive this component's inputs update at slightly
 *    different times. By 2s, both have fully settled.
 *
 * 4. No telemetry available. A principled choice would come from
 *    typing-pause distributions in this flow (95th percentile of
 *    inter-keystroke gaps). Without that data, 2s is a reasonable
 *    midpoint in the [1000, 3000]ms band of conventional soft-prompt
 *    delays.
 *
 * Tune from production feedback. Adjust if reports come in: advisors
 * complain about interruptions -> increase; advisors complain about
 * unresponsiveness -> decrease.
 */
// TODO: tune from production feedback (see JSDoc)
export const AUTOSELECT_SETTLE_MS = 2000;
